import { ZoomTranscriptStatus } from "~/providers/utils/types/consultation";

export const ZOOM_TRANSCRIPT_STATUS = {
  in_progress: "IN_PROGRESS",
  completed: "COMPLETED",
  failed: "FAILED",
} as const;

export const zoomTranscriptStatusColors: Record<ZoomTranscriptStatus, string> =
  {
    IN_PROGRESS: "bg-warning-complementary text-orange-900",
    COMPLETED: "bg-warning-complementary text-orange-900",
    FAILED: "bg-red-100 text-red-600",
  };

export const zoomTranscriptStatusLabels: Record<ZoomTranscriptStatus, string> =
  {
    IN_PROGRESS: "Pending",
    COMPLETED: "Pending",
    FAILED: "Failed",
  };
